/**
 * Current flow version with subdomain prefix
 * Format: {subdomain}-{version}
 *
 * Changelog:
 * app-1.0: Baseline (iframe flow)
 * staging-1.0: Baseline staging environment
 * internal-1.0: Baseline internal environment
 */

const getSubdomain = (): string => {
  if (typeof window === "undefined") return "unknown";

  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  // Extract first part as subdomain (app, staging, internal, etc.)
  return parts[0] || "unknown";
};

const PATIENT_BASE_VERSION = "4.0";
const ADMIN_BASE_VERSION = "4.0";
// 2.1 update text for state and other info
// 2.2 update text for other info form

export const FLOW_VERSION = `${getSubdomain()}-${PATIENT_BASE_VERSION}`;
export const BACKOFFICE_FLOW_VERSION = `${getSubdomain()}-backoffice-${ADMIN_BASE_VERSION}`;
